exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".padding {\r\n    margin-bottom: 5%;\r\n}\r\n\r\n.color:hover {\r\n    background-color: #007eed;\r\n}\r\n\r\n.color:active {\r\n    background-color: #0084b4;\r\n}\r\n\r\n.error {\r\n    border: 1px solid red;\r\n}\r\n\r\n.table-fixed thead {\r\n  width: 97%;\r\n}\r\n.table-fixed tbody {\r\n  height: 230px;\r\n  overflow-y: auto;\r\n  width: 100%;\r\n}\r\n.table-fixed thead, .table-fixed tbody, .table-fixed tr, .table-fixed td, .table-fixed th {\r\n  display: block;\r\n}\r\n.table-fixed tbody td, .table-fixed thead > tr> th {\r\n  float: left;\r\n  border-bottom-width: 0;\r\n}\r\n", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/~/css-loader!F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/app/main/systemTypeManagement/system-type-registration.component.css
 ** module id = 947
 ** module chunks = 2
 **/